import React, { useState } from "react";

export default function UserProfile({ data, onUpdate }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    fullName: data.fullName || "",
    gender: data.gender || "",
  });
  const [popup, setPopup] = useState(null);

  const handleEdit = () => {
    setIsEditing(true);
    setEditData({
      fullName: data.fullName || "",
      gender: data.gender || "",
    });
  };

  const handleSave = async () => {
    try {
      await onUpdate({ ...editData, userType: data.userType }); // keep original userType
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to update profile:", error);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditData({
      fullName: data.fullName || "",
      gender: data.gender || "",
    });
  };

  const handleInputChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const profileImgUrl =
    data.profileImageUrl ||
    "https://img.freepik.com/premium-vector/no-photo-available-vector-icon-default-image-symbol-picture-coming-soon-web-site-mobile-app_87543-18055.jpg";

  return (
    <div className="flex items-center space-x-4">
      <div className="relative">
        <img
          src={profileImgUrl}
          alt={data.fullName}
          className="w-20 h-20 rounded-full object-cover shadow-md border-2 border-white cursor-pointer"
          onClick={() => setPopup(profileImgUrl)}
        />
      </div>
      <div className="flex-1">
        {isEditing ? (
          <div className="space-y-3">
            {/* Full Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Full Name
              </label>
              <input
                type="text"
                value={editData.fullName}
                onChange={(e) => handleInputChange("fullName", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter full name"
              />
            </div>

            {/* Gender */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Gender
              </label>
              <select
                value={editData.gender}
                onChange={(e) => handleInputChange("gender", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Buttons */}
            <div className="flex space-x-2">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors text-sm font-medium"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-3">
              <h1 className="text-2xl font-bold text-gray-800">
                {data.fullName}
              </h1>
              <span
                className={`px-3 py-0.5 rounded-full text-xs font-semibold
                ${
                  data.status === "ACCEPTED" || data.status === "APPROVED"
                    ? "bg-green-100 text-green-800"
                    : data.status === "REJECTED"
                    ? "bg-red-100 text-red-800"
                    : data.status === "HOLD"
                    ? "bg-yellow-100 text-yellow-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {data.status}
              </span>
            </div>
            <div className="text-sm text-gray-500 flex gap-4 mt-2">
              <span>{data.userType}</span>
              {data.gender && <span>{data.gender}</span>}
            </div>
            <button
              onClick={handleEdit}
              className="mt-3 px-3 py-1 bg-gray-100 text-gray-600 rounded-md hover:bg-gray-200 transition-colors text-xs font-medium"
            >
              ✏️ Edit Profile
            </button>
          </>
        )}
      </div>

      {popup && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
          onClick={() => setPopup(null)}
        >
          <div
            className="relative bg-white p-4 rounded-lg shadow-2xl border border-gray-200 max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-3 right-3 bg-gray-800 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-700"
              onClick={() => setPopup(null)}
            >
              ✕
            </button>
            <div className="flex items-center justify-center">
              <img
                src={popup}
                alt="Profile Preview"
                className="max-h-[70vh] w-auto rounded-md"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
